export default __webpack_public_path__ + "static/media/bird.71e31e9e.png";